import { Fragment } from "react";
import parse from "html-react-parser";
import dynamic from "next/dynamic";
import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";
import { hasProperty } from "../../utils/validate";

import Error from "../_error";

const SEO = dynamic(() => import("../../components/Shared/SEO"));
const ProductLayout = dynamic(() => import("../../components/Layout/ProductLayout"));
const SmallBanner = dynamic(() => import("../../components/Shared/Banners/SmallBanner"));

const Page = props => {
	const { slug, token } = props;
	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(["legal", slug], [token]),
		queryFn: () => getQueryFn(`legal/${slug}`, token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	if (hasProperty(data, 'error')) {
		return <Error error={data.error} errorCode={data.error.code} />
	}

	return (
		<Fragment>
			<SEO seo={data.seo} />
			<ProductLayout
				nav={data.nav.header.links} logo={data.nav.header.logos.general} footer={data.nav.footer}>
				<SmallBanner banner={data.banner} h2={true} />
				<div className="legalBuilderHolder">
					<div className="customContainer">
						<div className="row">
							<div className="col s12">
								<div className="title">
									<h1>{data.title}</h1>
								</div>
								<div className="copy">
									{parse(data.copy)}
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col s12">
								<a
									className="goBack"
									href="/legal"
									title="Go Back"
								>
									<span>go back</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</ProductLayout>
		</Fragment>
	);
};

Page.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { slug, token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(["legal", slug], [token]),
		queryFn: () => getQueryFn(`legal/${slug}`, token),
		...queryConfig
	});
	return {
		slug: slug,
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default Page;